webpackJsonp([46233730848668],{

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(41);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Scroll = __webpack_require__(78);
	
	var _Scroll2 = _interopRequireDefault(_Scroll);
	
	var _Hero = __webpack_require__(61);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _SEO = __webpack_require__(37);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SiteData = {
	  title: 'Usługi',
	  slug: '/uslugi'
	};
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var edges = data.allServicesDataJson.edges;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_SEO2.default, { isSeo: true, siteData: SiteData, type: 'Local Business' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'theme-page padding-bottom-70' },
	      _react2.default.createElement(
	        _Hero2.default,
	        { image: data.servicesHero.sizes, heading: 'Zobacz co mo\u017Cemy dla Ciebie zrobi\u0107' },
	        _react2.default.createElement(
	          'div',
	          { className: ' margin-top-67 padding-bottom-20' },
	          _react2.default.createElement(
	            _Scroll2.default,
	            { type: 'id', element: 'services' },
	            _react2.default.createElement(
	              'a',
	              { className: 'more' },
	              _react2.default.createElement(
	                'span',
	                null,
	                'dowiedz si\u0119 wi\u0119cej'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'services', className: 'row gray full-width page-header vertical-align-table' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row full-width padding-top-bottom-50 vertical-align-cell' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'page-header-left' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'nasze us\u0142ugi'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page-header-right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'bread-crumb-container' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'JESTE\u015A TUTAJ:'
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'bread-crumb' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: '/' },
	                      'STRONA G\u0141\xD3WNA'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'separator' },
	                    '/'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'US\u0141UGI'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'services-list clearfix padding-top-70' },
	            edges.map(function (_ref2) {
	              var node = _ref2.node;
	              return _react2.default.createElement(
	                'li',
	                { key: node.name },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: node.slug, title: node.name },
	                  _react2.default.createElement(_gatsbyImage2.default, {
	                    sizes: data[node.image1].sizes,
	                    imgStyle: { objectPosition: '0 0' },
	                    style: { width: '100%', maxHeight: '247px' }
	                  }),
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'box-header' },
	                    node.name,
	                    _react2.default.createElement('span', { className: 'template-arrow-menu' })
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-uslugi-js-6d7ca243825ba76b0e3f.js